export const CONTRIBUTION_SEND = "CONTRIBUTION_SEND"
export const CONTRIBUTION_SEND_FAIL = "CONTRIBUTION_SEND_FAIL"